<div
  *ngIf="!loading && isLoggedIn"
  class="layout-wrapper"
  #projectFrame
  [ngClass]="{
    'p-input-filled': inputStyle === 'filled',
    'p-ripple-disabled': !ripple,
    'layout-menu-static': isStatic(),
    'layout-menu-overlay': isOverlay(),
    'layout-menu-horizontal': isHorizontal(),
    'layout-menu-slim': isSlim(),
    'layout-menu-active': menuActive,
    'layout-menu-mobile-active': mobileMenuActive,
    'layout-topbar-mobile-active': mobileTopbarActive,
    'layout-rightmenu-active': rightMenuActive,
    'layout-rtl': isRTL
  }"
  [class]="'layout-menu-' + menuTheme + ' layout-topbar-' + topbarTheme"
>
  <viggo-core-toolbar
    *ngIf="!firstContact"
    (onMenuButtonClick)="onMenuButtonClick($event)"
    (onTopbarMobileButtonClick)="onTopbarMobileButtonClick($event)"
    [appName]="appName"
    (activeTopbarItemEmit)="activeTopbarItem = $event"
    [logoToolBar]="logoToolBar"
    [mobileTopbarActive]="mobileTopbarActive"
    [showFastMenu]="true"
    [menuProfile]="menuProfile"
    [menuFast]="menuFast"
  >
  </viggo-core-toolbar>
  <viggo-core-toolbar
    *ngIf="firstContact"
    (onTopbarMobileButtonClick)="onTopbarMobileButtonClick($event)"
    [appName]="appName"
    (activeTopbarItemEmit)="activeTopbarItem = $event"
    [logoToolBar]="logoToolBar"
    [mobileTopbarActive]="mobileTopbarActive"
    [menuProfile]="menuProfile"
    [showMenuLeft]="false"
  >
  </viggo-core-toolbar>
  <div class="menu-wrapper" *ngIf="showMenu" (click)="onMenuClick($event)">
    <div class="layout-menu-container">
      <viggo-core-menu
        [menuItem]="menuItem"
        [isOverlay]="isOverlay()"
        [isHorizontal]="isHorizontal()"
        [isSlim]="isSlim()"
        [isMobile]="isMobile()"
        [isDesktop]="isDesktop()"
        [isStatic]="isStatic()"
      >
      </viggo-core-menu>
    </div>
  </div>

  <div class="layout-main" style="margin-left: 0 !important;">
    <viggo-core-header>
      <viggo-core-breadcrumb
        [disabledRoot]="firstContact"
        [useIcons]="true"
      ></viggo-core-breadcrumb>
    </viggo-core-header>
    <div class="layout-content bg-white">
      <router-outlet></router-outlet>
    </div>

    <viggo-core-footer
      [logoApp]="'assets/images/logo-viggo.png'"
    ></viggo-core-footer>
    <!--
    [whatsApp]="{show: true, link: 'https://web.whatsapp.com/'}"
    [instagram]="{show: true, link: 'https://www.instagram.com/viggosistemas/'}"
    [facebook]="{show: true, link: 'https://www.facebook.com/search/top?q=viggo%20sistemas'}" -->
  </div>
</div>
<div class="app-loading bg-primary" *ngIf="loading">
  <h4 class="text-splash">
    Estamos carregando um mundo completo todinho para você!
  </h4>
  <div class="content-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke-width="2"
        stroke-miterlimit="10"
      />
    </svg>
  </div>
</div>
